<template>
<div class="px-6 px-sm-10 py-8 primary white--text">
    <v-row class="d-flex">
        <v-col cols="12" sm="12" md="10" offset-md="1">
            <div class="display-1 font-weight-bold">CALIDAD MÁXIMA EN CADA PROCESO</div>
            <div class="title font-weight-medium">Cuéntanos tu proyecto.</div>
            <!-- <div class="">Tenemos presencia en Querétaro, Silao, Estado de México y Ciudad de México.</div> -->

            <v-row>
                <v-col cols="12" sm="5">
                    <v-text-field
                        :disabled="sending"
                        v-model="model.name"
                        label="Nombre"
                        maxlength="60"
                        solo dense
                        autocomplete="off"
                        @keydown.enter="validate"
                        class="mt-2">
                    </v-text-field>

                    <v-text-field
                        :disabled="sending"
                        v-model="model.email"
                        label="Correo"
                        maxlength="90"
                        solo dense type="email"
                        autocomplete="off"
                        @keydown.enter="validate"
                        class="mt-n3">
                    </v-text-field>

                    <v-select
                        :disabled="sending"
                        v-model="model.services"
                        :items="servicios"
                        item-text="text"
                        item-value="id"
                        solo multiple chips
                        append-icon="fa-angle-down accent--text"
                        label="Servicios"
                        class="mt-n3">
                    </v-select>

                    <div class="mt-n3">
                        <v-btn block class="accent" @click="validate" :disabled="sending">
                            <div class="font-weight-bold">Enviar</div>
                        </v-btn>
                    </div>
                </v-col>

                <v-col class="white--text pl-sm-10 mt-sm-2" cols="12" sm="4">
                    <div class="accent--text text--lighten-2 font-weight-bold body-2">CORREO</div>
                    <div class="body-2">atencionaclientes@msorting.com</div>

                    <div class="accent--text text--lighten-2 font-weight-bold body-2 mt-4">TELÉFONO</div>
                    <div class="body-2">+52 722 180 0637</div>

                    <div class="accent--text text--lighten-2 font-weight-bold body-2 mt-4">DIRECCIÓN</div>
                    <div class="body-2">
                        <div class="font-weight-bold">CENTRAL PARK</div>
                        <div class="caption" style="line-height:1.5">
                            Av. Armando Birlain Shaffer 2001<br>
                            Edificio 1 Piso 11, Centro Sur,<br>
                            76090, Querétaro.</div>
                    </div>
                    
                </v-col>

                <v-col class="white--text pl-sm-10 mt-sm-2" cols="12" sm="3">
                    <div class="white--text caption mb-2">Tenemos cobertura en:</div>
                    <div class="d-flex align-center">
                        <div>
                            <v-img 
                                :src="require(`@/assets/maya/_/lupa-morada.png`)" 
                                max-width="18px" alt="Mayasorting Isotipo"  contain>
                            </v-img>
                        </div>
                        <div class="font-weight-bold ml-2 mt-1 body-2">QUERÉTARO</div>
                    </div>
                    <div class="d-flex align-center mt-1">
                        <div>
                            <v-img 
                                :src="require(`@/assets/maya/_/lupa-morada.png`)" 
                                max-width="18px" alt="Mayasorting Isotipo"  contain>
                            </v-img>
                        </div>
                        <div class="font-weight-bold ml-2 mt-1 body-2">SILAO</div>
                    </div>
                    <div class="d-flex align-center mt-1">
                        <div>
                            <v-img 
                                :src="require(`@/assets/maya/_/lupa-morada.png`)" 
                                max-width="18px" alt="Mayasorting Isotipo"  contain>
                            </v-img>
                        </div>
                        <div class="font-weight-bold ml-2 mt-1 body-2">EDOMEX</div>
                    </div>
                    <div class="d-flex align-center mt-1">
                        <div>
                            <v-img 
                                :src="require(`@/assets/maya/_/lupa-morada.png`)" 
                                max-width="18px" alt="Mayasorting Isotipo"  contain>
                            </v-img>
                        </div>
                        <div class="font-weight-bold ml-2 mt-1 body-2">CDMX</div>
                    </div>
                </v-col>
            </v-row>
            
        </v-col>
    </v-row>
</div>
</template>

<script>
import Validation from '@/services/validation'
import Contact from '@/firebase/contact'

export default {
    data: () => ({
        sending: false,
        model: {
            name: '',
            email: '',
            services: ''
        },
        servicios: [
            {id: 'gp12', text: 'GP12'},
            {id: 'incoming-inspection', text: 'Incoming Inspection'},
            {id: 'cs', text: 'CS1 y CS2'},
            {id: 'retrabajos', text: 'Retrabajos'},
            {id: 'sorteos', text: 'Sorteos'},
            {id: 'ensambles', text: 'Ensambles'},
            {id: 'fulfillment', text: 'Fulfillment'},
        ]
    }),
    methods: {
        validate() {
            if (Validation.isEmpty(this.model.name)) {
                this.msgError('Es necesario tu nombre.');
                return;
            }
            if (Validation.isEmpty(this.model.email)) {
                this.msgError('Es necesario tu correo.');
                return;
            }
            if (!Validation.isEmail(this.model.email)) {
                this.msgError('Correo no válido.');
                return;
            }
            if (Validation.isEmpty(this.model.services)) {
                this.msgError('Selecciona al menos un servicio.');
                return;
            }

            this.send();
        },
        send() {
            this.sending = true;

            let est = '';
            this.model.services.forEach(dt => {
                est += dt + ' / ';
            })

            this.model.services = est;

            Contact.send(this.model)
                .then(response => {
                    if (response === true) {
                        this.msgSuccess('Mensaje enviado.');
                    } else {
                        this.msgError();
                    }

                    // this.sending = false;
                    this.model = {
                        name: '',
                        email: '',
                        services: ''
                    }
                })
        }
    }
}
</script>
